import { FullScreenLoading } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  useGetComparisonsQuery,
  useGetUserCollegesQuery,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.api';

import { Typography } from '@mui/material';

import { ComparePage } from './ComparePage';

export const ComparePageContainer = () => {
  const { data: list, isLoading: listLoading } = useGetUserCollegesQuery(undefined);
  const { data: comparisons, isLoading: comparisonsLoading } = useGetComparisonsQuery(undefined);

  if (listLoading || comparisonsLoading) {
    return <FullScreenLoading />;
  }

  if (!list || !comparisons) {
    return (
      <Typography variant="text-md-regular">
        {appStrings.modules.myColleges.compare.loadFailed}
      </Typography>
    );
  }

  return <ComparePage colleges={list.colleges} comparisons={comparisons} />;
};
